import React from "react";
import { useAppSelector } from "../../../redux/hooks";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "../../../components/ui/tooltip";
import { CalendarDays } from "lucide-react";

dayjs.extend(utc);
dayjs.extend(timezone);

function formatWithTz(
  dt: string | null | undefined,
  tz: string | null | undefined
) {
  if (!dt || !tz) return "-";
  let d: dayjs.Dayjs;
  try {
    d = dayjs.utc(dt).tz(tz);
  } catch {
    return "-";
  }
  if (!d.isValid() || d.toString() === "Invalid Date") return "-";
  return d.format("D MMM YYYY, hh:mm A") + ` (${d.format("z")})`;
}

export default function UserSelectedTimeFrame() {
  const settings = useAppSelector((state) => state.settings);
  const settingsTimezone = useAppSelector((state) => state.settings.timezone);

  const start = formatWithTz(settings.kanbanStartDateTime, settingsTimezone);
  const end = formatWithTz(settings.kanbanEndDateTime, settingsTimezone);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-2">
            <CalendarDays className="w-5 h-5 text-lime-300" />
            <span className="text-lime-50 font-medium">
              {start} <span className="mx-1 text-lime-200">—</span> {end}
            </span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            Current start and end date & time where appointments are pulled from
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
